import PropTypes from "prop-types";
import classnames from "classnames";
import Icon from "../../Icon";

const TableColumnHeadline = ({
  label,
  name,
  isSortable,
  className,
  ...restProps
}) => (
  <>
    {isSortable ? (
      <button
        className={classnames("table__column__headline", className)}
        name={name}
        {...restProps}
      >
        {label}
        <span className="table__column__headline__icon">
          <Icon name="system-open-up" theme="system" aria-hidden="true" />
          <Icon name="system-open-down" theme="system" aria-hidden="true" />
        </span>
      </button>
    ) : (
      <span className="table__column__headline">{label}</span>
    )}
  </>
);

TableColumnHeadline.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  isSortable: PropTypes.bool,
  className: PropTypes.string,
};

TableColumnHeadline.defaultProps = {
  label: "Account Name",
  name: "account_name",
  isSortable: true,
};

export default TableColumnHeadline;
